const shuffleArray = (array) => {
  const c = [...array];
  for (let i = c.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [c[i], c[j]] = [c[j], c[i]];
  }
  return c;
};

export function shuffle({ answers, shuffle = {} }) {
  let shuffledList;
  if (shuffle.exceptions && shuffle.exceptions.length > 0) {
    const arrayToShuffle = answers.filter((el) => !shuffle.exceptions.includes(el.i18n_key.split('.').slice(-1)[0]));
    const arrayToAppend = answers.filter((el) => shuffle.exceptions.includes(el.i18n_key.split('.').slice(-1)[0]));
    shuffledList = [...shuffleArray(arrayToShuffle), ...arrayToAppend];
  } else {
    shuffledList = shuffleArray(answers);
  }
  return shuffledList;
};
